import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightLocationBackDto } from '../../api/models/HeadWeightLocationBackDto';

export type TABLE_TYPE = Table<HeadWeightLocationBackDto>;

export const TABLE = 'headWeightLocationBack';
const SCHEMA = 'headWeightLocationBackId';

class HeadWeightLocationBackDatabase implements DataRepository<HeadWeightLocationBackDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightLocationBackDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightLocationBackDto, key: Key): Promise<HeadWeightLocationBackDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightLocationBackDto[]): Promise<HeadWeightLocationBackDto[]> {
    return this.db.transaction('rw', this.db[TABLE], async () => {
      await this.db[TABLE].clear();
      await this.db[TABLE].bulkPut(payload);
      return payload;
    });
  }

  list(): Promise<HeadWeightLocationBackDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightLocationBackDB = new HeadWeightLocationBackDatabase(db);
